module.exports = __webpack_public_path__ + "static/media/orderAndCart_deleteNow.9a83b415.png";